import type { ContentPage } from "@/lib/content/types";

// MIGRATED (Phase 3): faithful port of the former hand-coded
// app/(homes)/(hrms)/hrms-software/recruitment-management-systems/multi-platform-job-posting/page.jsx onto the content
// engine (template "hrmsFeature"). Copy, images, links and heading levels
// match the original. SEO still comes from GeneralPageSEOMetadata.json via
// <SEO> (its "multi-platform-job-posting" entry is kept); the seo block below is a fallback.

export const multiPlatformJobPosting: ContentPage = {
  slug: "recruitment-management-systems/multi-platform-job-posting",
  template: "hrmsFeature",
  seo: {
    title: "Expand Reach with Multi-Platform Job Posting",
    description: "Easily post jobs across multiple platforms with our automated job posting feature, increasing visibility and attracting a diverse pool of candidates.",
    keywords: [
      "job posting software",
      "multi-platform recruitment",
      "automated job distribution",
      "social media recruiting",
      "online job posting tools.",
    ],
    ogImage: "/assets/data/seoimages/multi-platform-job-posting.webp",
  },
  leaf: {
    hero: {
      caption: "Multi-Platform Job Posting",
      title: "Amplify Your Job Reach with Multi-Platform Posting",
      description: "Expand your talent search by posting jobs simultaneously across multiple job boards and social media platforms with a single click.",
      h1: "caption",
    },
    split: {
      title: "Centralize Your Recruitment Efforts",
      bullets: [
        { title: "One-Click Job Distribution", description: "Post to multiple job boards and networks simultaneously." },
        { title: "Major Platform Integration", description: "Seamlessly connect with LinkedIn, Indeed, and more." },
        { title: "Performance Tracking Analytics", description: "Monitor job posting performance and candidate sources." },
        { title: "Increased Job Visibility", description: "Save time while attracting diverse candidates effectively." },
      ],
      image: "/assets/images/img/product/hrms/recruitmentms/multi-platform-job-posting_image.webp",
      imageAlt: "multi-platform-job-posting_info",
    },
    cardsHeading: {
      title: "Key Features of Recruitment Management System",
      description: "Optimize Recruitment Management with advanced features designed to streamline tracking, automation, and customization.",
    },
    cards: [
      {
        title: "Resume Parsing",
        href: "/hrms-software/recruitment-management-systems/resume-parsing/",
        description: "Extract and analyze candidate information efficiently with our AI-driven resume parsing technology, speeding up the recruitment process.",
        image: "/assets/images/img/product/hrms/recruitmentms/resume-parsing.webp",
        imageAlt: "resume-parsing",
      },
      {
        title: "Candidate Communication",
        href: "/hrms-software/recruitment-management-systems/candidate-communication/",
        description: "Keep candidates informed and engaged throughout the recruitment process with automated, personalized communication tools.",
        image: "/assets/images/img/product/hrms/recruitmentms/candidate-communication_image.webp",
        imageAlt: "candidate-communication",
      },
      {
        title: "Interview Management",
        href: "/hrms-software/recruitment-management-systems/interview-management/",
        description: "Coordinate and manage candidate interviews efficiently with our comprehensive interview management system, optimizing recruitment.",
        image: "/assets/images/img/product/hrms/recruitmentms/interview-management_image.webp",
        imageAlt: "interview-management",
      },
      {
        title: "Reporting and Analytics",
        href: "/hrms-software/recruitment-management-systems/reporting-and-analytics/",
        description: "Utilize powerful analytics and customized reports to gain insights into your recruitment process, improving decision-making and strategy.",
        image: "/assets/images/img/product/hrms/recruitmentms/reporting-and-analytics_img.webp",
        imageAlt: "reporting-and-analytics",
      },
    ],
    testimonials: {
      title: "200+ Businesses across India love & trust us!",
      description: "Know why Superworks is the best HR software in India",
    },
    bookDemoTitle: "Broaden Your Recruiting Horizons Now!",
    relatedBlogsKeyword: "hrms-multi-platform-job-posting",
    metaKey: "multi-platform-job-posting",
  },
  sections: [],
};
